<template>
  <div class="flex items-center justify-center p-6 min-h-screen bg-indigo-800">
    <Head title="Register"/>
    <div class="w-full max-w-md">
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-4">
          <h1 class="text-center text-3xl font-bold">Welcome</h1>
          <div class="mt-6 mx-auto w-24 border-b-2" />
          <div v-if="Object.keys(form.errors).length > 0" class="flex items-center justify-between mb-8 max-w-3xl bg-red-500 rounded">
            <div class="flex items-center">
              <svg class="flex-shrink-0 ml-4 mr-2 w-4 h-4 fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" /></svg>
              <div class="py-4 text-white text-sm font-medium">Register Fail</div>
            </div>
          </div>
          <text-input v-model="form.username" :error="form.errors.username" class="mt-5" label="Username" autofocus
                      autocapitalize="off"/>
          <text-input v-model="form.nickname" :error="form.errors.nickname" class="mt-5" label="Nickname"
                      autocapitalize="off"/>
          <text-input v-model="form.corp" :error="form.errors.corp" class="mt-5" label="Corp" autocapitalize="off"/>
          <text-input autocomplete="new-password" v-model="form.password" :error="form.errors.password" class="mt-6"
                      label="Password" type="password"/>
          <label class="flex items-center mt-6 select-none" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox"/>
            <span class="text-sm">Remember Me</span>
          </label>
        </div>
        <div class="flex px-10 py-4 bg-gray-100 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Register</loading-button>
          <Link href="/login" class="ml-4 my-auto">Login</Link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue'
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
  },
  watch: {
    form: {
      handler: function (form) {
        console.log(form)
      },
      deep: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        username: 'noname',
        nickname: 'noname',
        corp: 'noname',
        password: '123456',
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/register')
    },
  },
}
</script>
